export const elements = {
	header: document.querySelector('header'),
	startButton: document.getElementById('startBtn'),
	stopButton: document.getElementById('stopBtn'),
	adbDevicesSelect: document.getElementById('devices'),
	refreshButton: document.getElementById('refreshButton'),
	resolutionSelect: document.getElementById('resolution'),
	customResolutionInput: document.getElementById('customResolution'),
	dpiSelect: document.getElementById('dpi'),
	customDpiInput: document.getElementById('customDpi'),
	resolutionLabel: document.getElementById('resolutionLabel'),
	dpiLabel: document.getElementById('dpiLabel'),
	rotationLockSelect: document.getElementById('rotationLock'),
	rotationLockLabel: document.getElementById('rotationLockLabel'),
	bitrateSelect: document.getElementById('bitrate'),
	customBitrateInput: document.getElementById('customBitrate'),
	maxFpsSelect: document.getElementById('maxFps'),
	noPowerOnInput: document.getElementById('noPowerOn'),
	turnScreenOffInput: document.getElementById('turnScreenOff'),
	powerOffOnCloseInput: document.getElementById('powerOffOnClose'),
	enableAudioInput: document.getElementById('enableAudio'),
	enableControlInput: document.getElementById('enableControl'),
	themeToggle: document.getElementById('themeToggle'),
	fullscreenBtn: document.getElementById('fullscreenBtn'),
	streamArea: document.getElementById('streamArea'),
	videoPlaceholder: document.getElementById('videoPlaceholder'),
	videoElement: document.getElementById('screen'),
	broadwayCanvas: document.getElementById('broadwayCanvas'),
    webcodecCanvas: document.getElementById('webcodecCanvas'),
	videoBorder: document.getElementById('videoBorder'),
	logArea: document.getElementById('logArea'),
	logContent: document.getElementById('logContent'),
	toggleLogBtn: document.getElementById('toggleLogBtn'),
	appDrawer: document.getElementById('appDrawer'),
	appDrawerContent: document.querySelector('.app-drawer-content'),
	appDrawerButton: document.querySelector('.app-drawer-button'),
	appGridContainer: document.getElementById('appGridContainer'),
	paginationContainer: document.querySelector('.drawer-pagination'),
	addWirelessDeviceBtn: document.getElementById('addWirelessDeviceBtn'),
	addWirelessDeviceModalOverlay: document.getElementById('addWirelessDeviceModalOverlay'),
	closeAddWirelessModalBtn: document.getElementById('closeAddWirelessModalBtn'),
	ipAddressInput: document.getElementById('ipAddressInput'),
	connectByIpBtn: document.getElementById('connectByIpBtn'),
	ipConnectStatus: document.getElementById('ipConnectStatus'),
	pairByQrBtn: document.getElementById('pairByQrBtn'),
	qrPairingModalOverlay: document.getElementById('qrPairingModalOverlay'),
	closeQrPairingModalBtn: document.getElementById('closeQrPairingModalBtn'),
	qrCodeDisplay: document.getElementById('qrCodeDisplay'),
	qrPairingStatus: document.getElementById('qrPairingStatus'),
	qrPairingSpinner: document.getElementById('qrPairingSpinner'),
	qrPairingMessage: document.getElementById('qrPairingMessage'),
	qrPairingDoneBtn: document.getElementById('qrPairingDoneBtn'),
	displayModeCheckboxes: document.querySelectorAll('input[name="displayMode"]'),
    rotateAdbButton: document.getElementById('rotateButton'),
	screenOffButton: document.getElementById('screenOffButton'),
	notificationPanelButton: document.getElementById('notificationPanelButton'),
	settingsPanelButton: document.getElementById('settingsPanelButton'),
	noPowerOnLabel: document.getElementById('noPowerOnLabel'),
	turnScreenOffLabel: document.getElementById('turnScreenOffLabel'),
	powerOffOnCloseLabel: document.getElementById('powerOffOnCloseLabel'),
    enableAudioLabel: document.querySelector('label[for=enableAudio]'),
    enableControlLabel: document.querySelector('label[for=enableControl]'),
    taskbar: document.querySelector('.custom-taskbar'),
    backButton: document.querySelector('.custom-taskbar .back-button'),
    homeButton: document.querySelector('.custom-taskbar .home-button'),
    recentsButton: document.querySelector('.custom-taskbar .recents-button'),
    speakerButton: document.getElementById('speakerButton'),
    quickSettingsTrigger: document.getElementById('quickSettingsTrigger'),
    batteryLevelSpan: document.getElementById('batteryLevel'),
    clockSpan: document.querySelector('.quick-settings-trigger .clock'),
    pinToggleButton: document.getElementById('pinToggleButton'),
    audioPanel: document.getElementById('audioPanel'),
    quickSettingsPanel: document.getElementById('quickSettingsPanel'),
    mediaVolumeSlider: document.getElementById('mediaVolume'),
    wifiToggleBtn: document.getElementById('wifiToggleBtn'),
    wifiIndicator: document.querySelector('.quick-settings-trigger .wifi-indicator'),
    batteryFill: document.querySelector('.battery-fill'),
    batteryIcon: document.querySelector('.battery-icon'),
    decoderTypeSelect: document.getElementById('decoderType'),
};